import { get } from 'lodash';
export function getBottomSpacerSection(_a) {
    var css = _a.css;
    var bodyBottomPadding = parseInt(get(css, 'so-global-body.paddingBottom'), 10) || 0;
    return {
        height: bodyBottomPadding,
        cssClass: '',
    };
}
//# sourceMappingURL=get-bottom-spacer-section.js.map